var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTumblr(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.7643 15.9756C15.4854 16.108 14.9521 16.2233 14.5544 16.2332C13.3538 16.2652 13.1207 15.3931 13.111 14.761V10.1105H16.1228V7.8486H13.1215V4.04321C13.1215 4.04321 10.9604 4.04321 10.9252 4.04321C10.889 4.04321 10.8259 4.07474 10.817 4.15474C10.6885 5.31938 10.1415 7.36349 7.86621 8.18084V10.1104H9.38406V14.9912C9.38406 16.6625 10.6216 19.0368 13.8887 18.9807C14.991 18.9619 16.2152 18.5024 16.4855 18.1056L15.7643 15.9756Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTumblr);
export default __webpack_public_path__ + "static/media/tumblr.79df471a.svg";
export { ForwardRef as ReactComponent };